import type { GroupId } from "@repo/app-types/entities/group";
import type { FC } from "react";
import { useAllTeammateGroupsQuery } from "../../api/entities/group";
import { TeammateGroupFilterItem } from "./teammateGroupFilterItem";

export interface ByGroupTeammateGroupFilterItemContainerProps {
  // `null` means "All teammate groups"; an array (possibly empty) is the
  // multi-select. There is no `undefined` state because this filter has
  // no teammate-preference load lifecycle.
  value: readonly GroupId[] | null;
  onChange: (newValue: readonly GroupId[] | null) => void;
}

const allTeammateGroupsLabel = "All teammate groups";

/**
 * Independent variant of {@link TeammateGroupFilterItemContainer} scoped
 * to the byGroup rollup page. Loads the teammate groups list and renders
 * a disabled picker while the list is loading. Reuses the presentational
 * {@link TeammateGroupFilterItem}; the independence is in the filter
 * state and the absence of a teammate-preference write path.
 */
export const ByGroupTeammateGroupFilterItemContainer: FC<
  ByGroupTeammateGroupFilterItemContainerProps
> = (props) => {
  const { data: groups } = useAllTeammateGroupsQuery();

  if (groups === undefined) {
    return (
      <TeammateGroupFilterItem
        allTeammateGroupsLabel={allTeammateGroupsLabel}
        value={null}
        groups={[]}
        onChange={() => {}}
        isDisabled
      />
    );
  }

  if (props.value === null && groups.length === 0) {
    return null;
  }

  return (
    <TeammateGroupFilterItem
      allTeammateGroupsLabel={allTeammateGroupsLabel}
      value={props.value}
      groups={groups}
      onChange={props.onChange}
    />
  );
};
